import type { HubModule } from "core-fe-lib/components-shadcn/shell/types";
import { pipelineRoutes } from "./routes";
import { getPipelineLinks } from "./links";

export const PipelineModule: HubModule = {
  id: "pipeline",
  name: "Pipeline",
  adminOnly: true,
  routes: (layouts) => pipelineRoutes(layouts.MainLayout),
  navLinks: (ctx) => getPipelineLinks(ctx.t),
};
